import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from 'src/app/core/store';
import { BaseComponent } from 'src/app/core/abstracts/baseComponent';
import {
  PayrollManagementAccessService,
  PayrollManagementTab
} from 'src/app/core/services/payroll-management-access.service';

@Component({
  selector: 'app-payroll-management-tabs',
  templateUrl: './payroll-management-tabs.component.html',
  standalone: false
})
export class PayrollManagementTabsComponent extends BaseComponent {
  tabs: PayrollManagementTab[] = [];

  constructor(store: Store<State>, access: PayrollManagementAccessService) {
    super();
    this.subs.push(store.select(state => state.accountState.user?.permissionIDs).subscribe(permissionIDs => {
      this.tabs = access.accessibleTabs(permissionIDs || []);
    }));
  }
}
